module.exports = __webpack_public_path__ + "static/media/carsafe_logo.1e4f523d.svg";